import Router from "next/router"
import { Analytics } from "@vercel/analytics/next"
import NProgress from "nprogress"
import { AppProvider } from "@/lib/contexts/appContext"
import { CartProvider } from "@/components/woocommerce/cartStore"
import "../styles/app.css"

NProgress.configure({
  showSpinner: false
})

Router.events.on("routeChangeStart", () => NProgress.start())
Router.events.on("routeChangeComplete", () => NProgress.done())
Router.events.on("routeChangeError", () => NProgress.done())

export default function App({ Component, pageProps }) {
  if (pageProps?.pathData) {
    return (
      <AppProvider pathData={pageProps.pathData}>
        <Component {...pageProps} />
        <Analytics />
      </AppProvider>
    )
  }

  return (
    <CartProvider>
      <Component {...pageProps} />
    </CartProvider>
  )
}
